export default "__VITE_ASSET__4aee9fe8__"